module.exports = __webpack_public_path__ + "img/sponsor-carousel-am.f7aa9e3f.jpg";